import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { selectUpcomingSurveyProceedPending } from '../../../../redux/surveys/selectors';
import { targetUserSelector } from '../../../../redux/context/selectors';

const mapStateToProps = state => ({
  surveyProceeding: selectUpcomingSurveyProceedPending(state),
  targetUser: targetUserSelector(state),
});
const mapDispatchToProps = {};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/TodoList/enhance.js